import { useMemo } from 'react';

import type { PetitionUpdatesData, PetitionUpdatesList, QueryState } from '#src/app/pages/petitionDetails/shared/types';

const UPDATES_PER_PAGE = 10;

export function useFetchMore(
	updatesData: PetitionUpdatesData | undefined,
	filteredUpdates: PetitionUpdatesList,
	setQueryState: (queryState: QueryState) => void,
): (() => void) | undefined {
	return useMemo(() => {
		if (!updatesData) {
			return undefined;
		}

		const { updates, endCursor, displayedCount } = updatesData;

		if (!endCursor && displayedCount >= filteredUpdates.length) {
			return undefined;
		}

		return () => {
			setQueryState({
				updates,
				cursor: endCursor,
				count: displayedCount + UPDATES_PER_PAGE,
			});
		};
	}, [updatesData, filteredUpdates, setQueryState]);
}
